import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en-US";

/**
 * Default: English only in the main bundle. When the host sends `jp`
 * via useUrfReceiveEvents, we load ja-JP on demand then changeLanguage.
 */
export const initI18n = async (language) => {
  const lng = language === "jp" ? "jp" : "en";

  try {
    if (!i18n.isInitialized) {
      await i18n.use(initReactI18next).init({
        resources: {
          en: { translation: en },
        },
        lng: "en",
        fallbackLng: "en",
        interpolation: {
          escapeValue: false,
        },
      });
    }

    if (lng === "jp") {
      if (!i18n.hasResourceBundle("jp", "translation")) {
        const jpModule = await import(
          /* webpackChunkName: "locale-ja-JP" */ "./ja-JP.js"
        );
        i18n.addResourceBundle(
          "jp",
          "translation",
          jpModule.default,
          true,
          true
        );
      }
      if (i18n.language !== "jp") {
        await i18n.changeLanguage("jp");
      }
    } else if (i18n.language !== "en") {
      await i18n.changeLanguage("en");
    }
  } catch (e) {
    console.error("initI18n failed", e);
    if (i18n.isInitialized && i18n.language !== "en") {
      await i18n.changeLanguage("en");
    }
  }
};

export default i18n;
